import Card from "components/entity/card/Card";
import { Flex } from "components/styled/Core.styles";

export const Landing = () => {

    return <>

        <Flex>
            <Card background="yellow">
                    <h3>Twitter</h3>
                    <p>Create twitter tweet meme</p>
            </Card>

        </Flex>

    </>
}

export default Landing;